import MdaeTagBox from "./component";
import { IMdaeDataUpdaterConfig } from "../../mdae-framework";
import { ITagBoxOptions } from "devextreme-react/tag-box";
export interface IMdaeMdaeTagBoxProps extends ITagBoxOptions {
  id: string;
  mdaeTagBoxTitle: string;
  mdaeDataUpdaterConfig?: Array<IMdaeDataUpdaterConfig>;
  required?: boolean;
  isAuditGroupWidget?: boolean;
  hasAllAuditGroupAccess?: boolean;
  isPageEditMode?: boolean;
  readOnlyTooltipContainerId?: string;
  auditGroupEntityName?: string;
  isFromPaymentRiskTab?: boolean;
}
export default MdaeTagBox;
